import { render, staticRenderFns } from "./PersonDiseasesManagement.vue?vue&type=template&id=526cf174&scoped=true"
import script from "./PersonDiseasesManagement.vue?vue&type=script&lang=js"
export * from "./PersonDiseasesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526cf174",
  null
  
)

export default component.exports